import { Controller } from "@hotwired/stimulus"
import { makeSendData } from "./lib/nvcat";

// Connects to data-controller="cash-receipt"
export default class extends Controller {
  static targets = ["recvData"]

  static values = {
    cancelUrl: String,
    cancelPaymentId: String
  }

  connect() {
    this.countdownInterval = null
    this.timeoutId = null

    this.boundClearTimers = this.clearTimers.bind(this)
    window.addEventListener("modals:timer:clear", this.boundClearTimers)
  }

  disconnect() {
    window.removeEventListener("modals:timer:clear", this.boundClearTimers)
    this.clearTimers()
  }

  isSubmitting = false

  formSubmit(event) {
    event.preventDefault()

    // 중복 클릭 방지
    if (this.isSubmitting) return

    this.isSubmitting = true

    const sendData = this.formSendData()
    const preparedData = makeSendData(sendData)
    this.requestData(preparedData).then()
  }

  formCancelSubmit(event) {
    event.preventDefault()

    if (this.isSubmitting) return

    this.isSubmitting = true

    const sendData = this.formCancelSendData()
    const preparedData = makeSendData(sendData)
    this.requestData(preparedData).then()
  }

  formSendData() {
    const FS = "\x1C"
    const H7 = "\x07"

    const money = this.element.querySelector("input[name='money']").value
    const tax = this.element.querySelector("input[name='tax']").value
    const bongsa = this.element.querySelector("input[name='bongsa']").value
    const catid = this.element.querySelector("input[name='catid']").value
    const myunse = this.element.querySelector("input[name='myunse']").value
    const cash_type = this.element.querySelector("input[name='cash_type']").value
    const halbu = this.element.querySelector("input[name='halbu']")?.value || "01"

    if (cash_type == "cash_keyin") {
      return (
          "NICEVCAT" + H7 + "0200" + FS + "21" + FS + "K" + FS + money + FS + tax + FS + bongsa + FS + halbu + FS + "" + FS + "" + FS + catid + FS + FS + FS + "" + FS + myunse + FS + FS + FS + FS + "" + FS + H7
      )
    }

    if (cash_type == "cash_card") {
      return (
          "NICEVCAT" + H7 + "0200" + FS + "21" + FS + "C" + FS + money + FS + tax + FS + bongsa + FS + halbu + FS + "" + FS + "" + FS + catid + FS + FS + FS + "" + FS + myunse + FS + FS + FS + FS + "CARD" + FS + H7
      )
    }

    if (cash_type == "cash_touch") {
      return (
          "NICEVCAT" + H7 + "0200" + FS + "21" + FS + "T" + FS + money + FS + tax + FS + bongsa + FS + halbu + FS + "" + FS + "" + FS + catid + FS + FS + FS + "" + FS + myunse + FS + FS + FS + FS + "" + FS
      )
    }
  }

  formCancelSendData() {
    const FS = "\x1C"
    const H7 = "\x07"

    const money = this.element.querySelector("input[name='money']").value
    const tax = this.element.querySelector("input[name='tax']").value
    const bongsa = this.element.querySelector("input[name='bongsa']").value
    const agreenum = this.element.querySelector("input[name='agreenum']").value
    const catid = this.element.querySelector("input[name='catid']").value
    const myunse = this.element.querySelector("input[name='myunse']").value
    const agreedate = this.element.querySelector("input[name='agreedate']").value
    const cash_type = this.element.querySelector("input[name='cash_type']").value
    const halbu = this.element.querySelector("input[name='halbu']")?.value || "01"

    if (cash_type == "cash_keyin") {
      return (
          "NICEVCAT" + H7 + "0420" + FS + "21" + FS + "K" + FS + money + FS + tax + FS + bongsa + FS + halbu + FS + agreenum + FS + agreedate + FS + catid + FS + FS + FS + "" + FS + myunse + FS + FS + FS + FS + "KEYIN" + FS + H7
      )
    }

    if (cash_type == "cash_card") {
      return (
          "NICEVCAT" + H7 + "0420" + FS + "21" + FS + "C" + FS + money + FS + tax + FS + bongsa + FS + halbu + FS + agreenum + FS + agreedate + FS + catid + FS + FS + FS + FS + myunse + FS + FS + FS + FS + "CARD" + FS + H7
      )
    }

    if (cash_type == "cash_touch") {
      return (
          "NICEVCAT" + H7 + "0420" + FS + "21" + FS + "T" + FS + money + FS + tax + FS + bongsa + FS + halbu + FS + agreenum + FS + agreedate + FS + catid + FS + FS + FS + FS + myunse + FS + FS + FS + FS + "" + FS + H7
      )
    }
  }

  async requestData(sendData) {
    try {
      const response = await fetch("http://localhost:9188", {
        method: "POST",
        headers: {"Content-Type": "text/plain"},
        body: sendData,
      })

      const data = await response.text()
      this.recvDataTarget.value = data

      if (data.length > 20) {
        const fields = data.split("\x1C")
        const approval_code = (fields[2] || "").trim()

        // alert(fields.map((v, i) => `[${i}] ${v}`).join("\n"))

        if (data.substring(16, 20) === "0210") {
          if (approval_code === "0000") {
            await this.submitCheckoutResult(data, sendData)
            this.openModal("현금 영수증이 발행 되었습니다.", "notice")
          } else {
            this.openModal(fields[16])
          }
        } else if (data.substring(16, 20) === "0430") {
          if (approval_code === "0000") {
            await this.submitCancelCheckoutResult(data, sendData)
            this.openModal("현금 영수증이 취소 되었습니다.", "notice")
          } else {
            this.openModal(fields[16])
          }
        } else this.openModal("승인 오류 입니다.")
      } else this.openModal("서버 통신 오류 입니다.")
    } catch (error) {
      console.error("AJAX 통신 실패! NVCAT 실행 여부 확인!", error)
      this.openModal("AJAX 통신 실패! NVCAT 실행 여부 확인!")
    } finally {
      this.isSubmitting = false
    }
  }

  async submitCheckoutResult(data, request) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content
    const pos = document.querySelector("input[name='pos']")?.value === "true"

    try {
      let posId
      let paymentId

      if (pos === true) {
        const params = new URLSearchParams(window.location.search)
        posId = params.get("pos_id")
        paymentId = params.get("payment_id")
      } else {
        posId = null
        paymentId = document.querySelector("input[name='payment_id']").value
      }

      const response = await fetch("/pos/cash_receipt_result", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
        },
        body: JSON.stringify({
          pos_id: posId,
          payment_id: paymentId,
          is_cancel: false,
          data: data,
          request: request,
        }),
      })

      if (!response.ok) new Error(`HTTP error! status: ${response.status}`)

      const result = await response.json()

      let resultUrl = "/receipts"
      if (pos === true) {
        const cash_only = document.querySelector("input[name='cash_only']").value
        resultUrl = `/pos/receipt_print?cash_only=${cash_only}&payment_id=${result.payment_id}&pos_id=${posId}`
      }

      window.location.href = resultUrl
    } catch (error) {
      console.error("서버에서 오류가 발생했습니다.", error)
      this.openModal("서버에서 오류가 발생했습니다. 관리자에게 문의 해주세요.")
    } finally {
      this.isSubmitting = false
    }
  }

  async submitCancelCheckoutResult(data, request) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content
    const paymentId = document.querySelector("input[name='payment_id']").value

    try {
      const response = await fetch("/pos/cash_receipt_result", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
        },
        body: JSON.stringify({
          payment_id: paymentId,
          is_cancel: true,
          data: data,
          request: request,
        }),
      })

      if (!response.ok) new Error(`HTTP error! status: ${response.status}`)

      await response.json()

      // 현금 결제 취소 API 호출
      if (this.hasCancelUrlValue) {
        const cancelRes = await fetch(this.cancelUrlValue, {
          method: "POST",
          headers: {
            "Accept": "application/json",
            "X-CSRF-Token": csrfToken
          },
          credentials: "same-origin"
        })
        const json = await cancelRes.json().catch(() => ({}))
        if (!cancelRes.ok || json.status !== "ok") {
          this.openModal(json.error || "결제 취소 실패")
          return
        }
      }

      setTimeout(() => {
        window.location.href = `/receipts${window.location.search}`
      }, 3000)
    } catch (error) {
      console.error("서버에서 오류가 발생했습니다.", error)
      this.openModal("서버에서 오류가 발생했습니다. 관리자에게 문의 해주세요.")
    } finally {
      this.isSubmitting = false
    }
  }

  openModal(message, textClass = "danger") {
    const url = `/modals/open?type=alert&close_button=false&message=${message}&text_class=${textClass}`

    fetch(url, {
      method: "POST", headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      }, body: JSON.stringify({turbo_frame: "modals"})
    })
        .then(response => {
          if (!response.ok) throw new Error("네트워크 오류")
          return response.text()
        })
        .then(html => {
          this.clearTimers()

          const modalsFrame = document.querySelector('turbo-frame[id="modals"]')
          if (modalsFrame) {
            modalsFrame.innerHTML = html

            // 카운트다운 초기화
            let countdown = 3
            const countdownElement = document.getElementById("close-countdown")
            if (countdownElement) {
              this.countdownInterval = setInterval(() => {
                countdown -= 1
                if (countdown > 0) {
                  countdownElement.textContent = countdown
                } else {
                  clearInterval(this.countdownInterval)
                  this.countdownInterval = null
                }
              }, 1000)
              this.timeoutId = setTimeout(() => {
                modalsFrame.innerHTML = ""
                this.timeoutId = null
              }, 3000)

            }
          }
        })
        .catch(error => console.error("에러:", error))
  }

  clearTimers() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval)
      this.countdownInterval = null
    }
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
      this.timeoutId = null
    }
  }
}
